var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "el-drawer",
        {
          attrs: {
            title: _vm.type == "add" ? "新增排班周期" : "编辑排班周期",
            visible: _vm.drawer,
            size: "700px",
            "before-close": _vm.handleClose,
            wrapperClosable: false,
          },
          on: {
            "update:visible": function ($event) {
              _vm.drawer = $event
            },
          },
        },
        [
          _c(
            "el-form",
            {
              ref: "ruleForm",
              staticClass: "demo-ruleForm",
              attrs: { "label-width": "90px" },
            },
            [
              _c(
                "el-form-item",
                [
                  _c("span", { attrs: { slot: "label" }, slot: "label" }, [
                    _c("span", { staticClass: "color-tab" }, [_vm._v("* ")]),
                    _vm._v("周期名称："),
                  ]),
                  _vm._v(" "),
                  _c("el-input", {
                    attrs: {
                      size: "small",
                      clearable: "",
                      placeholder: "请输入周期名称",
                    },
                    model: {
                      value: _vm.name,
                      callback: function ($$v) {
                        _vm.name = $$v
                      },
                      expression: "name",
                    },
                  }),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                [
                  _c("span", { attrs: { slot: "label" }, slot: "label" }, [
                    _c("span", { staticClass: "color-tab" }, [_vm._v("* ")]),
                    _vm._v("周期天数："),
                  ]),
                  _vm._v(" "),
                  _c("el-input-number", {
                    staticStyle: { width: "180px" },
                    attrs: { "controls-position": "right", min: 1, max: 31 },
                    model: {
                      value: _vm.cycle,
                      callback: function ($$v) {
                        _vm.cycle = $$v
                      },
                      expression: "cycle",
                    },
                  }),
                  _vm._v("\n        天\n        "),
                  _c("span", { staticClass: "tips" }, [
                    _vm._v("（以此数为周期进行循环，最大周期天数为31天）"),
                  ]),
                ],
                1
              ),
              _vm._v(" "),
              _c("div", { staticClass: "from-item-title mb15" }, [
                _c("span", [_vm._v("设置班次")]),
              ]),
              _vm._v(" "),
              _vm._l(_vm.cycle, function (index) {
                return _c(
                  "el-form-item",
                  { key: index },
                  [
                    _c("span", { attrs: { slot: "label" }, slot: "label" }, [
                      _c("span", { staticClass: "color-tab" }, [_vm._v("* ")]),
                      _vm._v("第" + _vm._s(index) + "天："),
                    ]),
                    _vm._v(" "),
                    _c(
                      "el-select",
                      {
                        staticStyle: { width: "100%" },
                        attrs: { placeholder: "请选择班次" },
                        model: {
                          value: _vm.shifts[index],
                          callback: function ($$v) {
                            _vm.$set(_vm.shifts, index, $$v)
                          },
                          expression: "shifts[index]",
                        },
                      },
                      _vm._l(_vm.shiftList, function (item) {
                        return _c("el-option", {
                          key: item.id,
                          attrs: { label: item.name, value: item.id },
                        })
                      }),
                      1
                    ),
                  ],
                  1
                )
              }),
            ],
            2
          ),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "button from-foot-btn fix btn-shadow" },
            [
              _c(
                "el-button",
                { attrs: { size: "small" }, on: { click: _vm.handleClose } },
                [_vm._v("取消")]
              ),
              _vm._v(" "),
              _c(
                "el-button",
                {
                  attrs: {
                    type: "primary",
                    loading: _vm.loading,
                    size: "small",
                  },
                  on: { click: _vm.submitForm },
                },
                [_vm._v("保存")]
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }